import { useAuth } from '@/store/useAuth';

import { api } from './api';

export interface MediaItem {
  id: number;
  source_url: string;
  title: string | null;
}

const MEDIA_BASE = '/media';

export const mediaApi = {
  list: (page = 1, perPage = 20) =>
    api.get<MediaItem[]>(`${MEDIA_BASE}?per_page=${perPage}&page=${page}`),

  uploadFile: async (file: File): Promise<MediaItem> => {
    const formData = new FormData();
    formData.append('file', file);
    // fetch cru (FormData não pode levar Content-Type: application/json, então não
    // dá pra usar o wrapper api). Mas o token PRECISA ir — senão o backend dá 401.
    const token = useAuth.getState().token;
    const response = await fetch('/api/v1/media/upload', {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: formData,
    });
    if (!response.ok) {
      throw new Error(`upload failed: ${response.status}`);
    }
    return response.json() as Promise<MediaItem>;
  },

  uploadFromUrl: (url: string, filename?: string) =>
    api.post<MediaItem>(`${MEDIA_BASE}/from-url`, { url, filename }),
};
